import Vue from 'vue'
import cHttp from '@/aplicacao/_constantes/Http'
import vCnpjValido from '@/aplicacao/_validadores/cnpjValido'
import sObjetos from '@/aplicacao/_servicos/objetos'
import sUtilitarios from '@/aplicacao/_servicos/utilitarios'
import sStores from '@/aplicacao/_servicos/stores'
import store from '@/configuracoes/stores'
import sProdutos from '../_servicos/produtos'

const State = (load) => ({

    pularAvisoSaida: false,

    solicitacao: Solicitacao(),

    motivos: [],

    estados: [],
    canais: [],

    estadoLabel: '',
    canalLabel: '',

    erros: [],

    carregando: true,

    salvando: false,

})

const Solicitacao = (load) => ({

    id: load ? (load.id ? parseInt(load.id) : sUtilitarios.randn()) : sUtilitarios.randn(),

    clienteExistente: false,

    cliente: {
        codigo: load ? (load.cliente ? (load.cliente.codigo ? load.cliente.codigo : '') : '') : '',
        cnpj: load ? (load.cliente ? (load.cliente.cnpj ? load.cliente.cnpj : '') : '') : '',
        razaoSocial: load ? (load.cliente ? (load.cliente.razaoSocial ? load.cliente.razaoSocial : '') : '') : '',
        nomeFantasia: load ? (load.cliente ? (load.cliente.nomeFantasia ? load.cliente.nomeFantasia : '') : '') : '',
        contato: {
            nome: load ? (load.cliente ? (load.cliente.contato ? (load.cliente.contato.nome ? load.cliente.contato.nome : '') : '') : '') : '',
            telefone: load ? (load.cliente ? (load.cliente.contato ? (load.cliente.contato.telefone ? load.cliente.contato.telefone : '') : '') : '') : '',
        },
    },

    motivo: load ? (load.motivo ? parseInt(load.motivo.id) : '') : '',

    estado: load ? (load.estado ? parseInt(load.estado.id) : '') : '',
    canal: load ? (load.canal ? parseInt(load.canal.id) : '') : '',

    tema: load ? (load.tema ? parseInt(load.tema.id) : '') : '',

    formato: {
        largura: load ? (load.formato ? (load.formato.largura ? parseFloat(load.formato.largura) : 0.0) : 0.0) : 0.0,
        altura: load ? (load.formato ? (load.formato.altura ? parseFloat(load.formato.altura) : 0.0) : 0.0) : 0.0,
    },

    produtos: [],

    observacoes: load ? (load.observacoes ? load.observacoes : '') : '',

})

const Produto = (load) => ({
    id: load ? (load.id ? parseInt(load.id) : sUtilitarios.randn()) : sUtilitarios.randn(),
    marca: {
        id: load ? (load.marca ? (load.marca.id ? parseInt(load.marca.id) : '') : '') : '',
        nome: load ? (load.marca ? (load.marca.nome ? load.marca.nome : '') : '') : '',
    },
    categoria: {
        id: load ? (load.categoria ? (load.categoria.id ? parseInt(load.categoria.id) : '') : '') : '',
        nome: load ? (load.categoria ? (load.categoria.nome ? load.categoria.nome : '') : '') : '',
    },
    produto: {
        id: load ? (load.produto ? (load.produto.id ? parseInt(load.produto.id) : '') : '') : '',
        codigo: load ? (load.produto ? (load.produto.codigo ? load.produto.codigo : '') : '') : '',
        descricao: load ? (load.produto ? (load.produto.descricao ? load.produto.descricao : '') : '') : '',
    },
    ppc: {
        valor1: load ? (load.ppc ? (load.ppc.valor1 ? parseFloat(load.ppc.valor1) : null) : null) : null,
        valor2: load ? (load.ppc ? (load.ppc.valor2 ? parseFloat(load.ppc.valor2) : null) : null) : null,
    },
    codigo: load ? (load.codigo ? load.codigo : '') : '',
    descricao: load ? (load.descricao ? load.descricao : '') : '',
    sellOut: load ? (load.sellOut ? true : false) : false,
    volumeEmEstoque: load ? (load.volumeEmEstoque ? parseInt(load.volumeEmEstoque) : 0) : 0,
    volumeProposto: load ? (load.volumeProposto ? parseInt(load.volumeProposto) : 0) : 0,
    valor: load ? (load.valor ? parseFloat(load.valor) : 0.0) : 0.0,
    observacoes: load ? (load.observacoes ? load.observacoes : '') : '',
    aberto: load ? (load.aberto ? true : false) : false,
})

const mutations = {

    resetar(state) { sObjetos.preencher(state, State()) },

    setPularAvisoSaida(state, payload) { state.pularAvisoSaida = payload },

    setErros(state, payload) { state.erros = payload },

    setCarregando(state, payload) { state.carregando = payload },

    setSalvando(state, payload) { state.salvando = payload },

    setMotivos(state, payload) { state.motivos = payload },

    setEstados(state, payload) { state.estados = payload },
    setCanais(state, payload) { state.canais = payload },

    clrEstados(state, payload) { Vue.set(state, 'estados', []) },
    clrCanais(state, payload) { Vue.set(state, 'canais', []) },

    setEstadoLabel(state, payload) { state.estadoLabel = payload },
    setCanalLabel(state, payload) { state.canalLabel = payload },

    setSolicitacao(state, payload) { state.solicitacao = payload },

    setSolicitacaoId(state, payload) { state.solicitacao.id = payload },

    setSolicitacaoClienteExistente(state, payload) { state.solicitacao.clienteExistente = payload },

    setSolicitacaoClienteCodigo(state, payload) { state.solicitacao.cliente.codigo = payload },
    setSolicitacaoClienteCnpj(state, payload) { state.solicitacao.cliente.cnpj = payload },
    setSolicitacaoClienteRazaoSocial(state, payload) { state.solicitacao.cliente.razaoSocial = payload },
    setSolicitacaoClienteNomeFantasia(state, payload) { state.solicitacao.cliente.nomeFantasia = payload },
    setSolicitacaoClienteContatoNome(state, payload) { state.solicitacao.cliente.contato.nome = payload },
    setSolicitacaoClienteContatoTelefone(state, payload) { state.solicitacao.cliente.contato.telefone = payload },

    setSolicitacaoMotivo(state, payload) { state.solicitacao.motivo = payload },

    setSolicitacaoEstado(state, payload) { state.solicitacao.estado = payload },
    setSolicitacaoCanal(state, payload) { state.solicitacao.canal = payload },

    setSolicitacaoTema(state, payload) { state.solicitacao.tema = payload },

    setSolicitacaoFormatoLargura(state, payload) { state.solicitacao.formato.largura = payload },
    setSolicitacaoFormatoAltura(state, payload) { state.solicitacao.formato.altura = payload },

    addSolicitacaoProduto(state, payload) { state.solicitacao.produtos.push(payload) },
    delSolicitacaoProduto(state, payload) { Vue.delete(state.solicitacao.produtos, payload.index) },
    clrSolicitacaoProduto(state, payload) { Vue.set(state.solicitacao, 'produtos', []) },
    setSolicitacaoProdutoAberto(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'aberto', payload.valor) },
    setSolicitacaoProdutoValor(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'valor', payload.valor) },
    setSolicitacaoProdutoSellOut(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'sellOut', payload.valor) },
    setSolicitacaoProdutoVolumeEmEstoque(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'volumeEmEstoque', payload.valor) },
    setSolicitacaoProdutoVolumeProposto(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'volumeProposto', payload.valor) },
    setSolicitacaoProdutoImagem(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'imagem', payload.valor) },
    setSolicitacaoProdutoImagemAberta(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'imagemAberta', payload.valor) },
    setSolicitacaoProdutoObservacoes(state, payload) { Vue.set(state.solicitacao.produtos[payload.index], 'observacoes', payload.valor) },

    setSolicitacaoObservacoes(state, payload) { state.solicitacao.observacoes = payload },

}

const actions = {

    resetar({ commit }) { commit('resetar') },

    cancelarAvisoSaida({ commit }, payload) { commit('setPularAvisoSaida', true) },

    setErros({ commit }, payload) { commit('setErros', payload) },

    setCarregando({ commit }, payload) { commit('setCarregando', payload) },

    setSalvando({ commit }, payload) { commit('setSalvando', payload) },

    setMotivos({ commit }, payload) { commit('setMotivos', payload) },

    setEstados({ commit }, payload) { commit('setEstados', payload) },
    setCanais({ commit }, payload) { commit('setCanais', payload) },

    clrEstados({ commit }, payload) { commit('clrEstados') },
    clrCanais({ commit }, payload) { commit('clrCanais') },

    setEstadoLabel({ commit }, payload) { commit('setEstadoLabel', payload) },
    setCanalLabel({ commit }, payload) { commit('setCanalLabel', payload) },

    setSolicitacao({ commit }, payload) { commit('setSolicitacao', payload) },

    setSolicitacaoId({ commit }, payload) { commit('setSolicitacaoId', parseInt(payload)) },

    setSolicitacaoClienteExistente({ commit }, payload) { commit('setSolicitacaoClienteExistente', payload) },

    setSolicitacaoClienteCodigo({ commit }, payload) { commit('setSolicitacaoClienteCodigo', payload) },
    setSolicitacaoClienteCnpj({ commit }, payload) { commit('setSolicitacaoClienteCnpj', payload) },
    setSolicitacaoClienteRazaoSocial({ commit }, payload) { commit('setSolicitacaoClienteRazaoSocial', payload) },
    setSolicitacaoClienteNomeFantasia({ commit }, payload) { commit('setSolicitacaoClienteNomeFantasia', payload) },
    setSolicitacaoClienteContatoNome({ commit }, payload) { commit('setSolicitacaoClienteContatoNome', payload) },
    setSolicitacaoClienteContatoTelefone({ commit }, payload) { commit('setSolicitacaoClienteContatoTelefone', payload) },

    setSolicitacaoMotivo({ commit }, payload) { commit('setSolicitacaoMotivo', '' === payload ? '': parseInt(payload)) },

    setSolicitacaoEstado({ commit }, payload) { commit('setSolicitacaoEstado', '' === payload ? '': parseInt(payload)) },
    setSolicitacaoCanal({ commit }, payload) { commit('setSolicitacaoCanal', '' === payload ? '': parseInt(payload)) },

    setSolicitacaoTema({ commit }, payload) { commit('setSolicitacaoTema', payload ? parseInt(payload) : '') },

    setSolicitacaoFormato({ commit }, payload) { commit('setSolicitacaoFormatoLargura', parseFloat(payload.largura)); commit('setSolicitacaoFormatoAltura', parseFloat(payload.altura)) },
    setSolicitacaoFormatoLargura({ commit }, payload) { commit('setSolicitacaoFormatoLargura', parseFloat(payload)) },
    setSolicitacaoFormatoAltura({ commit }, payload) { commit('setSolicitacaoFormatoAltura', parseFloat(payload)) },

    newSolicitacaoProduto({ commit }, payload) { commit('addSolicitacaoProduto', Produto(payload)) },
    delSolicitacaoProduto({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.id); commit('delSolicitacaoProduto', { index }) },
    clrSolicitacaoProduto({ commit }, payload) { commit('clrSolicitacaoProduto') },
    togSolicitacaoProduto({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.id); commit('setSolicitacaoProdutoAberto', { index, valor: !state.solicitacao.produtos[index].aberto }) },
    setSolicitacaoProdutoValor({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoValor', { index, valor: payload.valor }) },
    setSolicitacaoProdutoSellOut({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoSellOut', { index, valor: payload.valor }) },
    setSolicitacaoProdutoVolumeEmEstoque({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoVolumeEmEstoque', { index, valor: payload.valor }) },
    setSolicitacaoProdutoVolumeProposto({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoVolumeProposto', { index, valor: payload.valor }) },
    setSolicitacaoProdutoImagem({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoImagem', { index, valor: payload.valor }) },
    setSolicitacaoProdutoImagemAberta({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoImagemAberta', { index, valor: payload.valor }) },
    setSolicitacaoProdutoObservacoes({ commit, state }, payload) { let index = state.solicitacao.produtos.findIndex(p => p.id === payload.produto.id); commit('setSolicitacaoProdutoObservacoes', { index, valor: payload.valor }) },

    setSolicitacaoObservacoes({ commit }, payload) { commit('setSolicitacaoObservacoes', payload) },

    carregarClientePorCodigo({ dispatch }, codigo) {
        return new Promise(function(resolve, reject) {
            if ('' !== codigo) {
                dispatch('carregarCliente', { campo: 'codigo', dados: { codigo } })
                    .then(() => { resolve() })
                    .catch(() => { reject() })
            }
        })
    },

    carregarClientePorCnpj({ dispatch }, cnpj) {
        return new Promise(function(resolve, reject) {
            if ('' !== cnpj) {
                dispatch('carregarCliente', { campo: 'cnpj', dados: { cnpj } })
                    .then(() => { resolve() })
                    .catch(() => { reject() })
            }
        })
    },

    carregarCliente({ dispatch }, payload) {
        return new Promise(function(resolve, reject) {
            Vue.http.post(`cliente/buscar/${payload.campo}`, payload.dados)
                .then(res => res.json())
                .then(
                    res => {
                        dispatch('popularCliente', res.dados.cliente)
                            .then(() => {
                                dispatch('setSolicitacaoClienteExistente', true)
                                resolve()
                            })
                    },
                    err => {
                        if (cHttp.NOT_FOUND === err.data.codigo) {
                            dispatch('setSolicitacaoClienteExistente', false)
                            reject()
                        }
                    }
                )
        })
    },

    popularCliente({ dispatch }, cliente) {
        return new Promise(function(resolve, reject) {
            dispatch('setSolicitacaoClienteCodigo', cliente.codigo)
            dispatch('setSolicitacaoClienteCnpj', cliente.cnpj)
            dispatch('setSolicitacaoClienteRazaoSocial', cliente.razaoSocial)
            dispatch('setSolicitacaoClienteNomeFantasia', cliente.nomeFantasia ? cliente.nomeFantasia : '')
            dispatch('setSolicitacaoClienteContatoNome', cliente.contatoNome)
            dispatch('setSolicitacaoClienteContatoTelefone', cliente.contatoTelefone)
            resolve()
        })
    },

    novoCliente({ dispatch }) {

        return new Promise(function(resolve, reject) {

            dispatch('setSolicitacaoClienteExistente', false)

            dispatch('setSolicitacaoClienteCodigo', '')
            dispatch('setSolicitacaoClienteCnpj', '')
            dispatch('setSolicitacaoClienteRazaoSocial', '')
            dispatch('setSolicitacaoClienteNomeFantasia', '')
            dispatch('setSolicitacaoClienteContatoNome', '')
            dispatch('setSolicitacaoClienteContatoTelefone', '')

            resolve()

        })

    },

    incluirProduto({ dispatch }, produto) {
        dispatch('newSolicitacaoProduto', {
            marca: {
                id: produto.marca.id,
                nome: produto.marca.nome,
            },
            categoria: {
                id: produto.categoria.id,
                nome: produto.categoria.nome,
            },
            produto: {
                id: produto.id,
                codigo: produto.codigo,
                descricao: produto.descricao,
            },
            ppc: {
                valor1: produto.ppc.valor1,
                valor2: produto.ppc.valor2,
            },
            codigo: produto.codigo,
            descricao: produto.descricao,
        })
    },

    validarSalvarRascunho({ dispatch }) {
        dispatch('validarRascunho')
            .then(res => {
                if (confirm('Deseja realmente salvar um rascunho da solicitação?')) {
                    dispatch('cancelarAvisoSaida')
                    dispatch('setSalvando', true)
                    dispatch('salvarRascunho')
                }
            })
            .catch(() => {
                setTimeout(() => {
                    dispatch('geral/irParaTopo', null, { root: true })
                }, 100)
            })
    },

    validarSalvarEfetivacao({ dispatch }) {
        dispatch('validarEfetivacao')
            .then(res => {
                if (confirm('Deseja realmente efetivar esta solicitação?')) {
                    dispatch('cancelarAvisoSaida')
                    dispatch('setSalvando', true)
                    dispatch('salvarEfetivacao')
                }
            })
            .catch(() => {
                setTimeout(() => {
                    dispatch('geral/irParaTopo', null, { root: true })
                }, 100)
            })
    },

    validarSalvarAlteracoes({ dispatch }) {
        dispatch('validarAlteracoes')
            .then(res => {
                if (confirm('Deseja realmente salvar estas alterações?')) {
                    dispatch('cancelarAvisoSaida')
                    dispatch('setSalvando', true)
                    dispatch('salvarAlteracoes')
                }
            })
            .catch(() => {
                setTimeout(() => {
                    dispatch('geral/irParaTopo', null, { root: true })
                }, 100)
            })
    },

    validarRascunho({ state }) {

        return new Promise(function(resolve, reject) {

            let erros = []

            if ('' === state.solicitacao.estado) {
                erros.push('Estado é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.canal) {
                erros.push('Canal é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            state.erros = erros

            if (0 < state.erros.length) {
                reject()
            }

            resolve()

        })

    },

    validarEfetivacao({ state }) {

        return new Promise(function(resolve, reject) {

            let erros = []

            if ('' === state.solicitacao.motivo) {
                erros.push('Motivo é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.estado) {
                erros.push('Estado é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.canal) {
                erros.push('Canal é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.cliente.codigo) {
                erros.push('Código do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.cnpj) {
                erros.push('CNPJ do cliente é obrigatório na aba Passo 2 - CLIENTE')
            } else {
                if (!vCnpjValido(state.solicitacao.cliente.cnpj)) {
                    erros.push('CNPJ digitado é inválido na aba Passo 2 - CLIENTE')
                }
            }

            if ('' === state.solicitacao.cliente.razaoSocial) {
                erros.push('Razão social do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.nomeFantasia.toString().trim()) {
                erros.push('Nome fantasia do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.contato.nome) {
                erros.push('Nome do contato do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.contato.telefone) {
                erros.push('Telefone do contato do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if (!state.solicitacao.formato.largura || !state.solicitacao.formato.altura) {
                erros.push('Formato é obrigatório na aba Passo 3 - FORMATO')
            }

            if (('' !== state.solicitacao.estado) && ('' !== state.solicitacao.canal)) {

                if ('' === state.solicitacao.tema) {
                    erros.push('Tema é obrigatório na aba Passo 4 - TEMAS')
                }

                if (sProdutos.quantidadeMinima > state.solicitacao.produtos.length) {

                    erros.push(`É obrigatório encartar pelo menos ${sProdutos.quantidadeMinima} produtos na aba Passo 5 - PRODUTOS`)

                } else {

                    state.solicitacao.produtos.forEach(p => {

                        // AQUI - OCULTAÇÃO DE CAMPOS
                        //if (0 === p.volumeProposto) {
                        //    erros.push('Preencha o volume proposto do produto de código ' + p.produto.codigo + ' na aba Passo 5 - PRODUTOS')
                        //}

                        if (0 === p.valor) {
                            erros.push('Preencha o valor do produto de código ' + p.produto.codigo + ' na aba Passo 5 - PRODUTOS')
                        }

                    })

                }

            }

            state.erros = erros

            if (0 < state.erros.length) {
                reject()
            }

            resolve()

        })

    },

    validarAlteracoes({ state }) {

        return new Promise(function(resolve, reject) {

            let erros = []

            if ('' === state.solicitacao.motivo) {
                erros.push('Motivo é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.estado) {
                erros.push('Estado é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.canal) {
                erros.push('Canal é obrigatório na aba Passo 1 - MOTIVO, ESTADO E CANAL')
            }

            if ('' === state.solicitacao.cliente.codigo) {
                erros.push('Código do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.cnpj) {
                erros.push('CNPJ do cliente é obrigatório na aba Passo 2 - CLIENTE')
            } else {
                if (!vCnpjValido(state.solicitacao.cliente.cnpj)) {
                    erros.push('CNPJ digitado é inválido na aba Passo 2 - CLIENTE')
                }
            }

            if ('' === state.solicitacao.cliente.razaoSocial) {
                erros.push('Razão social do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.nomeFantasia.toString().trim()) {
                erros.push('Nome fantasia do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.contato.nome) {
                erros.push('Nome do contato do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if ('' === state.solicitacao.cliente.contato.telefone) {
                erros.push('Telefone do contato do cliente é obrigatório na aba Passo 2 - CLIENTE')
            }

            if (!state.solicitacao.formato.largura || !state.solicitacao.formato.altura) {
                erros.push('Formato é obrigatório na aba Passo 3 - FORMATO')
            }

            if (('' !== state.solicitacao.estado) && ('' !== state.solicitacao.canal)) {

                if ('' === state.solicitacao.tema) {
                    erros.push('Tema é obrigatório na aba Passo 4 - TEMAS')
                }

                if (sProdutos.quantidadeMinima > state.solicitacao.produtos.length) {

                    erros.push(`É obrigatório encartar pelo menos ${sProdutos.quantidadeMinima} produtos na aba Passo 5 - PRODUTOS`)

                } else {

                    state.solicitacao.produtos.forEach(p => {

                        // AQUI - OCULTAÇÃO DE CAMPOS
                        //if (0 === p.volumeProposto) {
                        //    erros.push('Preencha o volume proposto do produto de código ' + p.produto.codigo + ' na aba Passo 5 - PRODUTOS')
                        //}

                        if (0 === p.valor) {
                            erros.push('Preencha o valor do produto de código ' + p.produto.codigo + ' na aba Passo 5 - PRODUTOS')
                        }

                    })

                }

            }

            state.erros = erros

            if (0 < state.erros.length) {
                reject()
            }

            resolve()

        })

    },

    salvarRascunho({ dispatch }) {
        dispatch('salvar', 'box/formulario/salvar-rascunho')
            .then(res => {
                let solicitacaoId = res.dados.solicitacao.id
                Vue.router.push({ name: 'box-rascunhos' })
                dispatch('flash/setFlash', `Rascunho salvo com sucesso!`, { root: true })
            })
    },

    salvarEfetivacao({ dispatch }) {
        dispatch('salvar', 'box/formulario/salvar-efetivacao')
            .then(res => {
                let solicitacaoId = res.dados.solicitacao.id
                store.dispatch('pendencias/carregarBox')
                Vue.router.push({ name: 'box-sucesso', params: { id: solicitacaoId } })
            })
    },

    salvarAlteracoes({ dispatch }) {
        dispatch('salvar', 'box/formulario/salvar-alteracoes')
            .then(res => {
                let solicitacaoId = res.dados.solicitacao.id
                Vue.router.push({ name: 'box-fluxo', params: { id: solicitacaoId } })
                dispatch('flash/setFlash', `Alterações salvas com sucesso!`, { root: true })
            })
    },

    salvar({ state, dispatch, rootState }, rota) {

        return new Promise(function(resolve, reject) {

            dispatch('setSalvando', true)

            let dados = Object.assign({}, state.solicitacao)
            dados.usuario = rootState.sessao.usuario.id
            dados = sStores.stateParaFormData(dados)

            Vue.http.post(rota, dados)
                .then(res => res.json())
                .then(res => {
                    dispatch('setSalvando', false)
                    resolve(res)
                })

        })

    },

    carregarDataSourcesNovaSolicitacao({ dispatch }) {
        return new Promise((resolver, rejeitar) => {
            Promise.all([
                dispatch('carregarMotivos'),
                dispatch('carregarEstados'),
            ]).then(() => {
                dispatch('setCarregando', false)
                resolver()
            })
        })
    },

    carregarMotivos({ dispatch }) {
        return Vue.http.get('encartes/motivo')
            .then(res => res.json())
            .then(res => { dispatch('setMotivos', res.dados.motivos) })
    },

    carregarEstados({ dispatch, rootState }) {
        return Vue.http.get('box/campos-solicitacao/' + rootState.sessao.usuario.id + '/estados')
            .then(res => res.json())
            .then(res => {

                let estados = res.dados.estados

                dispatch('setEstados', estados)

                if (1 === estados.length) {
                    setTimeout(function() {
                        dispatch('setSolicitacaoEstado', estados[0].id)
                    }, 500)
                }

            })
    },

    carregarCanais({ state, dispatch, rootState }) {
        return Vue.http.get('box/campos-solicitacao/' + rootState.sessao.usuario.id + '/canais/' + state.solicitacao.estado)
            .then(res => res.json())
            .then(res => {

                let canais = res.dados.canais

                dispatch('setCanais', canais)

                if (1 === canais.length) {
                    setTimeout(function() {
                        dispatch('setSolicitacaoCanal', canais[0].id)
                    }, 500)
                }

            })
    },

    carregarSolicitacao({ dispatch }, id) {
        return Vue.http.get('box/solicitacao/' + id)
            .then(res => res.json())
            .then(res => { dispatch('popularSolicitacao', res.dados.solicitacao) })
    },

    popularSolicitacao({ dispatch }, solicitacao) {

        dispatch('setSolicitacaoId', solicitacao.id)

        dispatch('setSolicitacaoClienteExistente', solicitacao.clienteExistente)

        dispatch('setSolicitacaoClienteCodigo', solicitacao.cliente.codigo)
        dispatch('setSolicitacaoClienteCnpj', solicitacao.cliente.cnpj)
        dispatch('setSolicitacaoClienteRazaoSocial', solicitacao.cliente.razaoSocial)
        dispatch('setSolicitacaoClienteNomeFantasia', solicitacao.cliente.nomeFantasia)
        dispatch('setSolicitacaoClienteContatoNome', solicitacao.cliente.contato.nome)
        dispatch('setSolicitacaoClienteContatoTelefone', solicitacao.cliente.contato.telefone)

        dispatch('setSolicitacaoMotivo', solicitacao.motivo.id ? solicitacao.motivo.id : '')

        dispatch('setSolicitacaoEstado', solicitacao.estado.id)
        dispatch('setSolicitacaoCanal', solicitacao.canal.id)

        dispatch('setEstadoLabel', solicitacao.estado.sigla + ' - ' + solicitacao.estado.nome)
        dispatch('setCanalLabel', solicitacao.canal.nome)

        dispatch('setSolicitacaoTema', solicitacao.tema.id)

        dispatch('setSolicitacaoFormatoLargura', solicitacao.formato.largura)
        dispatch('setSolicitacaoFormatoAltura', solicitacao.formato.altura)

        solicitacao.produtos.forEach(solicitacaoProduto => {

            let solicitacaoProdutoParaAdicionar = {
                id: solicitacaoProduto.id,
                marca: {
                    id: solicitacaoProduto.marca.id,
                    nome: solicitacaoProduto.marca.nome ? solicitacaoProduto.marca.nome : '',
                },
                categoria: {
                    id: solicitacaoProduto.categoria.id,
                    nome: solicitacaoProduto.categoria.nome ? solicitacaoProduto.categoria.nome : '',
                },
                produto: {
                    id: solicitacaoProduto.produto.id,
                    codigo: solicitacaoProduto.produto.codigo ? solicitacaoProduto.produto.codigo : '',
                    descricao: solicitacaoProduto.produto.descricao ? solicitacaoProduto.produto.descricao : '',
                },
                codigo: solicitacaoProduto.codigo,
                descricao: solicitacaoProduto.descricao,
                ppc: {
                    valor1: (null === solicitacaoProduto.ppc.valor1 ) ? null : parseFloat(solicitacaoProduto.ppc.valor1),
                    valor2: (null === solicitacaoProduto.ppc.valor2 ) ? null : parseFloat(solicitacaoProduto.ppc.valor2),
                },
                sellOut: solicitacaoProduto.sellOut,
                volumeEmEstoque: solicitacaoProduto.volumeEmEstoque,
                volumeProposto: solicitacaoProduto.volumeProposto,
                valor: solicitacaoProduto.valor,
                observacoes: solicitacaoProduto.observacoes ? solicitacaoProduto.observacoes : '',
                aberto: false,
            }

            dispatch('newSolicitacaoProduto', solicitacaoProdutoParaAdicionar)

        })

        dispatch('setSolicitacaoObservacoes', solicitacao.observacoes)

        dispatch('setCarregando', false)

    },

}

const getters = {

    estadoAlterado: state => ({ estado: state.solicitacao.estado }),
    estadoCanalAlterado: state => ({ estado: state.solicitacao.estado, canal: state.solicitacao.canal }),

    clienteLiberado: state => !!state.solicitacao.estado && !!state.solicitacao.canal,

    temasLiberados: state => !!state.solicitacao.estado && !!state.solicitacao.canal,

    produtosLiberados: state => !!state.solicitacao.estado && !!state.solicitacao.canal,
    produtoJaIncluido: state => produto => 0 < state.solicitacao.produtos.filter(p => p.produto.id === produto.id).length,

}

export default {
    state: State(),
    mutations,
    actions,
    getters,
}
